import { Example } from "./Example";
import example1Img from "../../assets/example1.png";
import example2Img from "../../assets/example2.png";
import example3Img from "../../assets/example3.png";
import styles from "./Example.module.css";

interface ExampleC {
    title: string;
    text: string;
    value: string;
    icon: string;
}
const DEFAULT_EXAMPLES: ExampleC[] = [
    {
        title: "Analyze studies, reports, and benchmarking data.",
        text: "Discover what external and internal reports reveal about UNDP Serbia’s work, trends, and comparisons.",
        value: "Show me trends in digital inclusion from recent analytical reports.",
        icon: example1Img
    },
    {
        title: "Review outcomes, indicators, and achievements",
        text: "Explore key results and impact data from UNDP Serbia’s results framework",
        value: "What progress was made in women’s economic empowerment in 2025?",
        icon: example2Img
    },
    {
        title: "Transformative Change We’re Creating",
        text: "Discover the long-term effects of our digital, green, and gender-focused initiatives on people’s lives and the environment.",
        value: "What evidence shows sustained social and economic gains for women supported by UNDP Serbia?",
        icon: example3Img
    }
];

interface Props {
    onExampleClicked: (value: string) => void;
    useGPT4V?: boolean;
}

export const ExampleList = ({ onExampleClicked, useGPT4V }: Props) => {
    return (
        <div className={styles.examplesNavList}>
            {DEFAULT_EXAMPLES.map((question, i) => (
                <Example key={i} title={question.title} text={question.text} value={question.value} icon={question.icon} onClick={onExampleClicked} />
            ))}
        </div>
    );
};
